module.exports = __webpack_public_path__ + "img/order.39c39fe6.svg";